import {useRef} from 'react'

import {twMerge} from '@sdox/utils'

import {useDesignDebugger} from '../Debugger'

import type {ComponentProps, ReactNode} from 'react'
import type {ClassNameValue} from 'tailwind-merge'

export interface SectionContainerProps extends Omit<ComponentProps<'div'>, 'className'> {
  children?: ReactNode
  className?: ClassNameValue
}

export const SectionContainer = (props: SectionContainerProps) => {
  const {children, className, ...restProps} = props
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const ref = useRef<HTMLDivElement>(null!)
  useDesignDebugger(ref, 'SectionContainer')

  return (
    <div
      ref={ref}
      className={twMerge(
        'max-w-section @container/section',
        '[--gap-section:12px] sm:[--gap-section:32px]',
        'mb-spacing-48',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  )
}
